import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CashierResponse } from 'src/app/models/cashier.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { User } from 'src/app/models/user.model';
import { CashierService } from 'src/app/services/cashier.service';
import { RolesAndPermissionsService } from 'src/app/services/roles-and-permissions.service';
import { AuthenticationService } from '../../../authentication/authentication/authentication.service';
import { WarehouseResponse } from 'src/app/models/warehouse.model';
import { WarehouseService } from 'src/app/services/warehouse.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-cashiers',
  templateUrl: './cashiers.component.html',
  styleUrls: ['./cashiers.component.scss']
})
export class CashiersComponent implements OnInit {

  categorySelected = null;
  cashiers: CashierResponse[] = [];
  creating = false;
  editing = false;
  newCashier: CashierResponse = new CashierResponse();
  alwaysCreating = false;
  users: User[] = [];
  warehouses: { [key: number]: WarehouseResponse } = {};

  constructor(
    private cashierService: CashierService,
    private toastService: ToastrService,
    private roleService: RolesAndPermissionsService,
    private authService: AuthenticationService,
    private warehouseService: WarehouseService
  ) {

  }

  resetNewCashier() {
    this.newCashier = new CashierResponse();
  }

  cancelNewFamily() {
    if (!this.alwaysCreating) {
      this.creating = false
    }
    this.resetNewCashier();
  }

  ngOnInit(): void {
    this.getUsers();
    this.getCashiers();
    this.getWarehouses();
  }

  getWarehouses() {
    this.warehouseService.getWarehouses().subscribe({
      next: (response: ResponseObject) => {
        var list = response.data as WarehouseResponse[];
        list.forEach((warehouse) => {
          this.warehouses[warehouse.id] = warehouse;
        })
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  closeModal(changed: boolean) {

    if (this.creating) {
    }
    this.creating = false;
    this.editing = false;
  }

  getUsers() {
    this.roleService.getUsers(parseInt(this.authService.getCurrentCompanyId())).subscribe({
      next: (response: ResponseObject) => {
        this.users = response.data as User[];
      },
      error: (error: any) => {
        this.toastService.error("Error al obtener los usuarios, por favor recarga la página");
      }
    })
  }

  getUserName(userId: number) {
    var temp = "Desconocido";
    var findOut = this.users.find((u) => {
      return u.id == userId;
    })
    if (findOut) {
      return findOut.email;
    }
    return temp;
  }

  getCashiers() {
    this.cashierService.getCashiers().subscribe({
      next: (response: ResponseObject) => {
        this.cashiers = response.data as CashierResponse[];
      },
      error: (error: any) => {
        this.toastService.error("Error al obtener las cajas, por favor recarga la página");
      }
    })
  }

  editAndSave(cashier: any) {
    if (!cashier.warehouse) {
      cashier.warehouse = null;
    }
    this.newCashier = cashier;
    this.editing = true;
    this.getCashiers();
  }

  createAndSave() {
    this.newCashier = new CashierResponse();
    this.creating = true;
    this.getCashiers();
  }

  activeOrInactive(cashier: any) {
    this.cashierService.deleteCashier(cashier.id).subscribe({
      next: (response: any) => {
        cashier.active = !cashier.active;
        this.toastService.success("Se ha " + ((cashier.active) ? 'activado' : 'desactivado') + " correctamente la caja");
      },
      error: (error: any) => {
        this.toastService.success("Error al " + (cashier.active) ? 'desactivar' : 'activar' + " la caja");
      }
    })
  }
}
